<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">
            RELATÓRIO DE ADIANTAMENTO
          </h4>
          <div>
            <BaseFiltroRelatorio
              tipo="basico"
              @imprimir="imprimir"
              @pesquisar="pesquisar"
            />
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BaseInput, BaseFiltroRelatorio } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseInput,
    BaseFiltroRelatorio,
  },
  computed: {},
  data() {
    return {
      isLoading: false,
    };
  },
  mounted() {},
  methods: {
    pesquisar(event) {
      console.log("Clicou em pesquisar");
      console.log(event);
      console.log("-------------------");
    },
    imprimir(event) {
      console.log("Clicou em imprimir");
      console.log(event);
      console.log("-------------------");
    },
  },
  watch: {},
};
</script>
<style></style>
